var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._l((_vm.blocks),function(block,index){return _c('Block',{key:index,staticClass:"politique",attrs:{"block":block}})}),_c('Footer',{attrs:{"with-links":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }